<template>
    <div :class="config.rootClass">
        <div style="height: 0.41rem"></div>
        <Headbar :backgroundColor="config.background" :text="config.text"></Headbar>
        <div class="warp" v-if="state == 1 || state == 0 || state == null">
            <div
                class="radio-chunk"
                :style="{
                    padding:
                        pickUpRadio == 0
                            ? '2.5rem 1.5rem 0.4rem 1.5rem'
                            : '0.5rem 1.5rem 0.4rem 1.5rem'
                }"
                v-if="!isLocked"
            >
                <!-- 交通方式选择自驾时，需求只读不可选择 -->
                <van-radio-group v-model="pickUpRadio" direction="horizontal" :disabled="readonly">
                    <van-radio name="1">需要{{ config.label }}</van-radio>
                    <van-radio name="0">无需{{ config.label }}</van-radio>
                </van-radio-group>
            </div>
            <template v-if="!(status == 10 || status == 20)">
                <div class="warp-header">
                    <p>
                        <img src="@assets/pick_up_car.png" alt="" />
                        <span>{{ car.useDate }}</span>
                    </p>
                    <p>
                        <span>{{ getCustomStatusMap(status) }}</span>
                    </p>
                </div>
                <div class="master-information">
                    <span class="label">{{ config.label }}人：</span>
                    <div class="master-name">
                        <span>{{ car.name }}</span>
                    </div>
                    <div class="master-contact">
                        <span @click="sendSms">发短信</span>
                        <span @click="callPhone">打电话</span>
                    </div>
                </div>
                <div class="master-tips" v-if="status == 30 || status == 40 || status == 50">
                    <span>{{ config.label }}人员会提前联系您，请您保持电话畅通</span>
                </div>
                <div class="station-information">
                    <div class="station-time">
                        <span class="time">
                            <span class="cricle"></span>
                            {{ car.plannedArrivalTime | formatTime }}
                        </span>
                        <span class="tips">{{ config.timeLabel }}</span>
                    </div>
                    <div class="from-to">
                        <div class="from-to-left">
                            <p>
                                <img src="@assets/start.svg" alt="" />
                            </p>
                            <p class="line"></p>
                            <p>
                                <img src="@assets/end.svg" alt="" />
                            </p>
                        </div>
                        <div class="from-to-right">
                            <p class="van-multi-ellipsis--l2">
                                <span class="van-multi-ellipsis--l2">{{ pickupPointDetail }}</span>
                            </p>
                            <p class="van-multi-ellipsis--l2">
                                <span class="van-multi-ellipsis--l2">
                                    {{ car.dropoffPoint || config.dropoffPlaceholder }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <div class="status-10-chunk" v-if="status == 10">
                <span>您当前选择为无需{{ config.label }}</span>
            </div>
            <div v-if="status == 20" class="status-20-chunk">
                <div class="state-2-tips" v-if="pickUpRadio == 0">
                    您当前选择无需{{ config.label }}
                </div>
                <noData
                    v-if="pickUpRadio == 1"
                    :text="config.arrangeText"
                    :algin="'center'"
                    :icon="require('@assets/car_no_data.png')"
                ></noData>
            </div>
        </div>
        <div class="warp" v-else>
            <noData
                v-if="config.showEmptyNoData"
                :icon="require('@assets/self.png')"
                :title="`无需${config.label}`"
                :text="`您已设置为无需${config.label}，如需安排${config.label}请联系您的专属秘书`"
            ></noData>
        </div>
        <!-- 无需接站、无需送站二次确认（备注非必填） -->
        <no-need-dialog
            v-model="showNoNeedDialog"
            :title="config.label"
            :tip="`您是否确认${config.trip}【无需${config.label}】服务？`"
            :handler="handleNoNeed"
        ></no-need-dialog>
    </div>
</template>

<script>
import utils from '@utils/index.js'
import noData from '@components/Common/NoData.vue'
import Headbar from './Headbar.vue'
import NoNeedDialog from './NoNeedDialog.vue'
import itineraryMixin from './itineraryMixin'

// 来程接站、返程送站的差异配置：direction 1 来程 2 返程
const DIRECTION_CONFIG = {
  1: {
    rootClass: 'incoming-pickup',
    text: '接站',
    background: 'linear-gradient(180deg, #FA6400 0%, #943B00 100%)',
    trip: '来程',
    label: '接站',
    timeLabel: '计划接站时间',
    // 待安排时的提示文案
    arrangeText: '最晚在您到达前一天，显示接站信息',
    dropoffPlaceholder: '--',
    cabStateKey: 'outboundCabState',
    cabRemarkKey: 'outboundCabRemark',
    // state 为「后台不安排」时父级已隐藏该模块，此处与原有组件保持一致（来程为空）
    showEmptyNoData: false
  },
  2: {
    rootClass: 'return-pickup',
    text: '送站',
    background: 'linear-gradient(270deg, #FFF1C6 0%, #FFBE0C 99%)',
    trip: '返程',
    label: '送站',
    timeLabel: '预计出发时间',
    arrangeText: '最晚在您出发前一天，显示送站信息',
    dropoffPlaceholder: '',
    cabStateKey: 'returnCabState',
    cabRemarkKey: 'returnCabRemark',
    showEmptyNoData: true
  }
}

export default {
  mixins: [itineraryMixin],
  components: {
    Headbar,
    noData,
    NoNeedDialog
  },
  props: {
    // 1 来程接站 2 返程送站
    direction: {
      type: [String, Number],
      default: 1
    },
    // 接站、送站信息
    car: {
      type: Object,
      default: () => ({})
    },
    receptionPlaces: {
      type: Array,
      default: () => []
    },
    // 接站、送站需求：1 需要 0 无需
    state: {
      type: [String, Number],
      default: null
    },
    status: {
      type: [String, Number],
      default: null
    },
    // 交通方式选择自驾时，需求只读，不可切换
    readonly: {
      type: Boolean,
      default: false
    },
    dictsCodeMap: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showNoNeedDialog: false
    }
  },
  filters: {
    formatTime (val) {
      if (!val) return
      // 接送站时间来自接口字符串，统一格式化避免 split 时间缺失时报错。
      return utils.dealFormData(val, 'Y-m-d h:m:s').slice(0, 16)
    }
  },
  computed: {
    config () {
      return DIRECTION_CONFIG[Number(this.direction)] || DIRECTION_CONFIG[1]
    },
    // 已上车、已送达、他人已接时隐藏服务选项，禁止切换
    isLocked () {
      return [60, 70, 71].includes(Number(this.status))
    },
    pickUpRadio: {
      get () {
        if (this.state === null || this.state === undefined || this.state === '') return null
        return String(this.state)
      },
      set (val) {
        if (this.readonly) return
        if (String(val) === String(this.state)) return
        // 需要：直接保存
        if (String(val) === '1') {
          const { cabStateKey, trip, label } = this.config
          this.saveItinerary({ [cabStateKey]: 1 }, `${trip}${label}您已选择【需要${label}】方式`)
          return
        }
        // 无需：二次确认弹窗，确认后才提交
        this.showNoNeedDialog = true
      }
    },
    // 上车点详情
    pickupPointDetail () {
      // car.pickupPoint：接车、送车地点；receptionPlaces：接待点列表（type 1 接站 2 送站）
      if (this.receptionPlaces && this.receptionPlaces.length && this.car) {
        const val = {
          placeName: this.car.pickupPoint,
          type: this.car.type
        }
        const target = this.receptionPlaces.find(item => {
          const keys = Object.keys(val)
          return keys.every(key => item[key] == val[key])
        }) || {}
        return target.placeDesc || '--'
      }
      return this.car && this.car.pickupPoint || '--'
    }
  },
  methods: {
    getCustomStatusMap (status) {
      const type = Number(this.direction)
      const customMap = {
        '20': '待安排',
        '71': type == 1 ? '他人已接站' : '他人已送站'
      }
      const dictText = (this.dictsCodeMap['guest_cab_status'] || {})[status + '']
      const txt = customMap[status] || dictText
      return utils.dealDictText(txt, type)
    },
    callPhone () {
      window.location.href = 'tel://' + this.car.phone
    },
    sendSms () {
      window.location.href = 'sms:' + this.car.phone
    },
    // 无需确认后提交需求与备注
    handleNoNeed (remark) {
      const { cabStateKey, cabRemarkKey, trip, label } = this.config
      const payload = {
        [cabStateKey]: 0
      }
      if (remark) payload[cabRemarkKey] = remark
      return this.saveItinerary(payload, `${trip}${label}您已选择【无需${label}】方式`)
    }
  }
}
</script>

<style lang="scss" scoped>
.incoming-pickup,
.return-pickup {
    .warp {
        margin-top: -1rem;
        background: #fff;
        padding: 0 0.29rem 0.21rem;
        border-radius: 0.41rem;

        .warp-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 1.64rem;

            p:nth-child(1) {
                display: flex;
                align-items: center;

                > img {
                    width: 0.74rem;
                    height: 0.74rem;
                    margin-right: 0.16rem;
                }

                > span {
                    font-size: 0.57rem;
                    font-weight: 500;
                    color: #162b40;
                }
            }

            p:nth-child(2) {
                display: flex;
                align-items: center;

                > span {
                    font-size: 0.57rem;
                    color: #0072f5;
                }
            }
        }

        .master-information {
            position: relative;
            z-index: 2;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 2.3rem;

            padding: 0 0.3rem;
            background: #eff2f9;
            border-radius: 0.26rem;

            .label {
                display: flex;
                font-size: 0.45rem;
                color: rgba(22, 43, 64, 0.45);
            }

            .master-name {
                flex: 1;
            }

            .master-name span {
                font-size: 0.57rem;
                font-weight: 500;
                color: #162b40;
                text-align: left;
            }

            .master-contact {
                display: flex;
                align-items: center;

                > span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 2.87rem;
                    height: 1.31rem;
                    background: #ffffff;
                    border-radius: 0.62rem;
                    font-size: 0.57rem;
                    color: #162b40;
                }

                span:nth-child(1) {
                    margin-right: 0.41rem;
                }
            }
        }

        .master-tips {
            position: relative;
            z-index: 1;
            margin-top: -0.3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 1.6rem;
            padding-top: 0.3rem;
            border-radius: 0.26rem;
            border: 0.04rem solid #ececec;

            > span {
                font-size: 0.45rem;
                color: #fa6400;
            }
        }

        .station-information {
            margin-top: 0.41rem;
            padding-bottom: 0.21rem;
        }

        .station-time {
            display: flex;
            flex: 1;
            align-items: start;
            margin-bottom: 0.41rem;

            .cricle {
                width: 0.21rem;
                height: 0.21rem;
                background: rgba(22, 43, 64, 0.45);
                border-radius: 100%;
                margin-right: 0.16rem;
            }

            .time {
                display: flex;
                align-items: center;

                font-size: 0.56rem;
                font-weight: 500;
                color: #162b40;
            }

            .tips {
                margin-left: 0.42rem;
                display: flex;
                flex: 1;
                font-size: 0.45rem;
                color: rgba(22, 43, 64, 0.45);
            }
        }

        .from-to {
            display: flex;
            position: relative;

            p {
                display: flex;
                align-items: flex-start;

                > span {
                    margin-top: -0.09rem;
                    margin-left: 0.16rem;
                    font-size: 0.57rem;
                    color: rgba(22, 43, 64, 0.85);
                }

                > img {
                    width: 0.82rem;
                    height: 0.57rem;
                }
            }

            .from-to-left {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;

                p:nth-child(3) {
                    height: 1.5rem;
                }

                p:nth-child(1) {
                    height: auto;
                }
            }

            .from-to-right {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                p:nth-child(2) {
                    height: 1.5rem;
                }

                p:nth-child(1) {
                    height: auto;
                }
            }

            .line {
                margin: 0.53rem 0.81rem;
                width: 0.02rem;
                height: 0.68rem;
                background: #dcdee0;
            }
        }
    }

    ::v-deep {
        .no-data {
            background: #fff;
            height: 9.56rem;
            padding: 0.21rem 0;
            overflow: hidden;
            border-radius: 0.41rem;

            > img {
                position: absolute;
                top: 0.21rem;
                left: 0;
                width: 100%;
                bottom: 0.21rem;
                height: 9.56rem;
            }

            > span {
                color: #162b40;
            }
        }
    }
    .status-20-chunk,
    .status-10-chunk {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        min-height: 5rem;
        span {
            font-size: 0.57rem;
            color: #535d6d !important;
        }
    }
    .radio-chunk {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 0.5rem 1.5rem 0.4rem 1.5rem;

        ::v-deep .van-radio-group--horizontal {
            width: 100% !important;
            justify-content: space-between !important;
        }
    }
    .state-2-tips {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.57rem;
        color: #535d6d !important;
        height: 2rem;
    }
}

/* 返程沿用原视觉：无数据图带圆角 */
.return-pickup {
    ::v-deep .no-data > img {
        border-radius: 0.41rem;
    }
}
</style>
